import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CompanyShare } from 'types/CompanyEntity'

interface DelistedHistoryTableRowProps {
    date: string | null
    share: CompanyShare
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const DelistedHistoryTableRow = ({
    date,
    share,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: DelistedHistoryTableRowProps) => {
    const { t } = useTranslation()

    const delistedReason = share.delistedReason ? t(`site.instruments.${share.delistedReason}`) : null
    const delistedReasonText = delistedReason ? ` (${delistedReason})` : ''
    return (
        <TableRow>
            <TableCell>{date}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{share.symbol}</TableCell> : null}
            <TableCell>
                Avnotering av {share.instrumentName}
                {delistedReasonText}
            </TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
